import { captureEvent } from '../../../../../../../analytics/analytics';
import { EVENT_NAMES, EVENT_TYPES } from '../../../../../../../analytics/analytics-constants';

export const faOnListFilterApply = (key, value) => {
  captureEvent({
    event_type: EVENT_TYPES.USER_ACTION,
    event_name: EVENT_NAMES.FILTER_APPLIED,
    event_value: `filter_apply|${key}_${value}`,
  });
};

export const faOnListFilterRemove = (key, value) => {
  captureEvent({
    event_type: EVENT_TYPES.USER_ACTION,
    event_name: EVENT_NAMES.BUTTON_CLICK,
    event_value: `filter_remove|${key}_${value}`,
  });
};

export const faOnSearchApply = (key, value) => {
  captureEvent({
    event_type: EVENT_TYPES.USER_ACTION,
    event_name: EVENT_NAMES.BUTTON_CLICK,
    event_value: `filter_apply|${key}_${value}`,
  });
};
